import React, {useEffect} from 'react';

import {batch, useDispatch, useSelector} from 'react-redux';

import * as loadingActions from '@/actions/loadingActions';
import * as setupActions from '@/actions/setupActions';
import {Post} from '@/api/request';
import Button from '@/components/button/Button';
import {DEFAULT_CLEANING_TYPE, DEFAULT_RINSING_DURATION} from '@/constants/calibrationWizardConstant';
import * as APPDATA from '@/constants/pcConstAppData';
import * as APPSTYLE from '@/constants/pcConstAppStyle';
import {getCleaningProperties} from '@/selectors/setupSelector';

import {INITIAL_CUSTOM_OPERATION} from '../../../stores/reducers/setupStore';

function CompleteRinse() {
  const dispatch = useDispatch();
  const cleaningProperties = useSelector(getCleaningProperties);

  const resetCleaningProperties = {
    isCleaningWizardRunning: false,
    cleaningDuration: undefined,
    cleaningSolution: 15,
    valveChipType: 6,
    [APPDATA.KEY.MembraneCutOffSize]: undefined,
  };

  useEffect(() => {
    setupTopMenuOnFinish();
  }, []);

  const setupTopMenuOnFinish = () => {
    const topButtonProperties = undefined;
    const backButtonProperties = {
      id: APPDATA.BACK,
      label: '',
      disabled: true,
      onClick: cleaningWizardBackAction,
    };
    const titleMenuProperties = APPDATA.CLEANING_WIZARD;
    setTopMenuProperties(topButtonProperties, backButtonProperties, titleMenuProperties);
  };

  const setTopMenuProperties = (topButtonProperties, backButtonProperties, titleMenuProperties) => {
    dispatch(
      setupActions.setTopMenuProperties({
        topButtonProperties:
          topButtonProperties === undefined
            ? undefined
            : {
                id: topButtonProperties.id,
                label: topButtonProperties.label,
                disabled: topButtonProperties.disabled,
                onClick: topButtonProperties.onClick,
              },
        backButtonProperties:
          backButtonProperties === undefined
            ? undefined
            : {
                id: backButtonProperties.id,
                label: backButtonProperties.label,
                disabled: backButtonProperties.disabled,
                onClick: backButtonProperties.onClick,
              },
        titleMenuProperties,
      }),
    );
    dispatch(setupActions.topButtonTertiaryProperties(undefined));
  };

  const cleaningWizardBackAction = () => {
    batch(() => {
      dispatch(loadingActions.showLoading(false));
      // need to reset the current store value for Custom Operation
      dispatch(setupActions.SetCleaningCustomOperation(INITIAL_CUSTOM_OPERATION));
      dispatch(setupActions.setCleaningProperties(resetCleaningProperties));
      window.location.href = APPDATA.HOME_SCREEN_ADDRESS;
    });
  };

  const onClick = (e) => {
    switch (e.currentTarget.id) {
      case APPDATA.BTN_EXIT:
        batch(() => {
          dispatch(loadingActions.showLoading(false));
          // need to reset the current store value for Custom Operation
          dispatch(setupActions.SetCleaningCustomOperation(INITIAL_CUSTOM_OPERATION));
          dispatch(setupActions.setCleaningProperties(resetCleaningProperties));
          dispatch(setupActions.nextActionWizard(false));
          window.location.href = APPDATA.HOME_SCREEN_ADDRESS;
        });
        break;
      case APPDATA.BTN_REPEAT: {
        const cleaningParams = {
          CleaningType: DEFAULT_CLEANING_TYPE,
          CleaningDuration: DEFAULT_RINSING_DURATION,
          MembraneCutOffSize: cleaningProperties[APPDATA.KEY.MembraneCutOffSize]?.toString() || '',
        };

        dispatch(setupActions.nextActionWizard(false));

        Post(
          APPDATA.API.POST_START_CLEANIG_WIZARD,
          cleaningParams,
          successStartCleaningWizard,
          undefined,
          failedStartCleaningWizard,
        );

        break;
      }
      default:
        break;
    }
  };

  const successStartCleaningWizard = (response) => {
    window.location.href = APPDATA.RINSE_WIZARD_ADDRESS;
    let tempCleaningProperties = {...cleaningProperties};
    const responseData = response.data;
    tempCleaningProperties = {
      ...tempCleaningProperties,
      cleaningDuration: responseData.CleaningDuration,
      valveChipType: responseData.ValveChipType,
      CleaningType: responseData.CleaningType,
      MembraneCutOffSize: responseData.MembraneCutOffSize,
      isCleaningWizardRunning: true,
    };

    dispatch(setupActions.setCleaningProperties(tempCleaningProperties));
    dispatch(
      setupActions.backButtonProperties({
        id: APPDATA.BACK,
        label: '',
        disabled: true,
        onClick,
      }),
    );
  };

  const failedStartCleaningWizard = () => {};

  return (
    <div className="complete-wizard center rinse-page">
      <div className="complete-text">
        <br />
        <span className="title-text">
          <b>The Rinsing Cycle is Completed</b>
          <br />
          <br />
        </span>
        <span className="body-text">Refill the tubes with the same solution to repeat the Rinsing Cycle.</span>
      </div>
      <div className="complete-button bottomMenu-show">
        <div className={`${APPSTYLE.COLUMN_1}colButtonBottomMenu`}>
          <Button
            id={APPDATA.BTN_EXIT}
            label={APPDATA.BTN_EXIT}
            onClick={onClick}
            className="buttonBottomMenu secondary-button"
          />
        </div>
        <div className={`${APPSTYLE.COLUMN_1}colButtonBottomMenu`}>
          <Button
            id={APPDATA.BTN_REPEAT}
            label={APPDATA.BTN_REPEAT}
            onClick={onClick}
            className="buttonBottomMenu primary-button"
          />
        </div>
      </div>
    </div>
  );
}
export default CompleteRinse;
